export const KOREAN_TIME_ZONE = 'Asia/Seoul';
